import { render, staticRenderFns } from "./OrganizationLetter.vue?vue&type=template&id=8f5b9c42"
import script from "./OrganizationLetter.vue?vue&type=script&lang=js"
export * from "./OrganizationLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports